import { get, post } from "./apiManagerV2";

class PaymentService {
  static async makeOnlineAppointment({
    paymentMethod = "Pay Online",
    couponCode = "",
    sessionId,
    patientId,
    id = 0,
    paymentGatewayRef,
    madeVia = "Web",
    ServiceId
  }) {
    return await post({
      path: "/appointments/make-online-appointment",
      requestBody: {
        PaymentMethod: paymentMethod,
        CouponCode: couponCode,
        SessionId: sessionId,
        PatientId: patientId,
        Id: id,
        PaymentGatewayRef: paymentGatewayRef,
        MadeVia: madeVia,
        ServiceId
      },
    });
  }

  static async verifyPayment({
    merchantID,
    paymentGatewayRef,
    extRefId,
    instituteId = process.env.REACT_APP_INSTITUTE_ID,
  }) {
    return await post({
      path: "/appointments/verify-payment",
      requestBody: {
        MerchantID: merchantID,
        PaymentGatewayRef: paymentGatewayRef,
        ExtRefId: extRefId,
        InstituteId: instituteId,
      },
    });
  }

  static async makeOrder({
    doctorId,
    channelingFee,
    isOtherCountry,
    patientEmail,
    patientMobileNo,
    patientId,
    serviceName,
  }) {
    return await fetch(`${process.env.REACT_APP_IPG_URL}/add/order`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        extRefId: doctorId,
        amount: channelingFee,
        currency: isOtherCountry ? "USD" : "LKR",
        returnUrl: process.env.REACT_APP_PAYMENT_CALLBACK_URL,
        customerMail: patientEmail,
        customerMobile: patientMobileNo,
        orderSummary: serviceName || "Video Consultation Fee",
        instituteId: process.env.REACT_APP_INSTITUTE_ID,
        customerReference: patientId,
      }),
    }).then((res) => res.json());
  }

  static async getBillData({ appointmentId }) {
    return await get({
      path: `${process.env.REACT_APP_API_BASE_URL}/bill/get?appointmentId=${appointmentId}`,
    });
  }

  static async getDoctorPaymentPolicy({
    InstituteBranchId,
    DoctorId,
    SessionType,
  }) {
    return await post({
      path: "/doctor/get-doctor-payment-policy",
      requestBody: {
        InstituteBranchId,
        DoctorId,
        SessionType,
      },
    });
  }
}

export default PaymentService;
